function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgBrowseIconFilled = function SvgBrowseIconFilled(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "m9.5 4.917-6.5-1v10.48l6.5 1.5zM10.5 4.917v10.98l6.5-1.5V3.918z"
  }));
};
export default SvgBrowseIconFilled;